module.exports = __webpack_public_path__ + "img/feel-good-stretches-side-body-stretch.63c274c8.png";